module.exports = __webpack_public_path__ + "static/media/nynfc_logo.9f4ad94d.svg";